import { ConfigApi, createApiRef, FetchApi } from '@backstage/core-plugin-api';
import { MembershipResponse, SecretsResponse } from '../types';

type Options = {
  configApi: ConfigApi;
  fetchApi: FetchApi;
};

export const infisicalApiRef = createApiRef<InfisicalAPI>({
  id: 'plugin.infisical',
});

export class InfisicalAPI {
  private readonly backendUrl: string | undefined;
  private readonly fetchApi: FetchApi;

  constructor(options: Options) {
    this.backendUrl = options.configApi.getOptionalString('backend.baseUrl');
    this.fetchApi = options.fetchApi;
  }

  private async getUrls() {
    return {
      apiUrl: `${this.backendUrl}/api/infisical/`,
    };
  }

  async getSecrets(workspaceId: string, environment = 'dev'): Promise<SecretsResponse> {
    const { apiUrl } = await this.getUrls();

    const response = await this.fetchApi.fetch(
      `${apiUrl}secrets/${workspaceId}/${environment}`,
      {
        method: 'GET',
      },
    );

    if (!response.ok) {
      throw new Error(`Failed to get secrets: ${response.statusText}`);
    }

    return response.json();
  }

  async getMemberByUsername(workspaceId: string, username: string) : Promise<MembershipResponse>{
    const { apiUrl } = await this.getUrls();

    const response = await this.fetchApi.fetch(
      `${apiUrl}members/${workspaceId}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "username": username
        })
      },
    );

    if (!response.ok) {
      throw new Error(`Failed to get member: ${response.statusText}`);
    }

    return response.json();
  }
}
